<template lang="pug">
    .container-fluid.flex.column.center.gap-2
        vm-row.flex.center.gap-0(vm-w="12")
          vm-col(vm-w="4")
            .flex.end.gap-1.mw-90
                .bold {{$t('strings.supplier')}}
                type-ahead-select(:data="purchases.suppliers" @search="loadSuppliers" showColumn="name" @item-select="selectSupplier" @deselect="deselectSupplier")
          vm-col(vm-w="4")
            .flex.end.gap-1.mw-90
                .bold {{$t('strings.project')}}
                type-ahead-select(:data="purchases.projects" @search="loadProjects" showColumn="name" @item-select="selectProject" @deselect="deselectProject")
          vm-col(vm-w="4")
            .flex.end.gap-1.mw-95
                .bold {{$t('strings.date')}}
                date-picker-dashboard(:currentDate="true" @action="selectDate")
        vm-row.flex.center.gap-0(vm-w="12")
            vm-col(vm-w="3")
                card-resize-dashboard(id="card_dashboard_7" :text="supplier" :title="$t('strings.supplier')" :cash="false")
            vm-col(vm-w="3")
                card-resize-dashboard(id="card_dashboard_6" :text="project" :title="$t('strings.project')" :cash="false")
            vm-col(vm-w="3")
                card-resize-dashboard(id="card_dashboard_8" :amount="purchases.totalAmount" :title="$t('strings.total')")
            vm-col(vm-w="3")
                card-resize-dashboard(id="card_dashboard_9" :text="purchases.totalQuantity" :title="$t('strings.total_purchase_orders')" :cash="false")
        vm-row(vm-w="12")
            .bold Ordenes de Compra
        vm-row.margin-bottom(vm-w="12")
            table-dashboard(:orderBy="true" :id="true" translations="purchase_orders" :centerRows="true" :totalPages="purchases.purchaseOrders.totalPages" :data="purchases.purchaseOrders.data" :columns="columnsPurchaseOrders" @loadRecords="loadSuppliesQuery" @search="onSearch" @order="onChangeOrder" @filter="onChangeFilter" :typeFilters="purchases.unitFilters" @clickDelete="onSearch('')")
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import moment from 'moment'

import parserFilters from '@/utils/parserFilters'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')

const Card = () => import('@/components/aditionals/Card.vue')
const MoneyCard = () => import('@/components/aditionals/MoneyCard.vue')
const DatePickerDashboard = () => import('@/components/dashboard/DatePickerDashboard.vue')
const TypeAheadSelect = () => import('@/components/aditionals/TypeAheadSelect.vue')
const TableDashboard = () => import('@/components/dashboard/TableDashboard.vue')
const CardResizeDashboard = () => import('@/components/dashboard/CardResizeDashboard.vue')

export default {
  name: 'PurchasesDashboard',
  components: {
    DatePickerDashboard,
    MoneyCard,
    Card,
    TypeAheadSelect,
    TableDashboard,
    CardResizeDashboard
  },
  data () {
    return {
      project: '-',
      supplier: '-',
      date: '',
      columnsPurchaseOrders: [
        'id',
        'description',
        'unit_of_measurement',
        'quantity'
      ],
      filtersPurchaseOrders: {
        where: {
          created_at: moment().format('YYYY-MM'),
          param: ''
        },
        whereIn: {
          supplier_id: [],
          project_id: []
        }
      },
      filtersSupplies: {
        where: {
          description: ''
        },
        whereIn: {
          supplier_id: [],
          project_id: [],
          id: [],
          unit_of_measurement: []
        },
        orderBy: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'purchases'
    ])
  },
  created () {
    this.loadAllData()
  },
  methods: {
    ...mapActions([
      'loadPurchaseOrdersCatalog',
      'loadSuppliesIds',
      'loadTotalAmountPurchaseOrders',
      'setTotalAmount',
      'setTotalQuantity',
      'loadSupplies',
      'clearPurchaseOrdersTable'
    ]),
    selectSupplier (supplier) {
      this.supplier = supplier.name
      this.filtersPurchaseOrders.whereIn.supplier_id = [supplier.id]
      this.filtersSupplies.whereIn.supplier_id = [supplier.id]
      this.loadAllData()
    },
    selectProject (project) {
      this.project = project.name
      this.filtersPurchaseOrders.whereIn.project_id = [project.id]
      this.filtersSupplies.whereIn.project_id = [project.id]
      this.loadAllData()
    },
    selectDate (date) {
      this.date = (date.length === 7) ? date : ''
      this.filtersPurchaseOrders.where.created_at = this.date
      this.loadAllData()
    },
    deselectSupplier () {
      this.supplier = '-'
      this.filtersPurchaseOrders.whereIn.supplier_id = []
      this.filtersSupplies.whereIn.supplier_id = []
      this.loadAllData()
    },
    deselectProject () {
      this.project = '-'
      this.filtersPurchaseOrders.whereIn.project_id = []
      this.filtersSupplies.whereIn.project_id = []
      this.loadAllData()
    },
    onSearch (input) {
      this.filtersSupplies.where.description = input
      this.loadSuppliesQuery()
    },
    onChangeOrder (orderBy) {
      this.filtersSupplies.orderBy = orderBy.replace(new RegExp('dsc', 'g'), 'desc')
      this.loadSuppliesQuery()
    },
    onChangeFilter (filter) {
      this.filtersSupplies.whereIn.unit_of_measurement = filter
      this.loadSuppliesQuery()
    },
    loadSuppliers (value) {
      this.loadPurchaseOrdersCatalog({ filter: `?param=${value},name`, url: 'suppliers' })
    },
    loadProjects (value) {
      this.loadPurchaseOrdersCatalog({ filter: `?param=${value},name`, url: 'projects' })
    },
    loadSuppliesQuery (page = 1) {
      this.loadSupplies({ page: page, filters: parserFilters(this.filtersSupplies) })
    },
    loadAllData (page = 1) {
      this.loadSuppliesIds({ filters: parserFilters(this.filtersPurchaseOrders) }).then(response => {
        if (response.quantity_purchase_orders) {
          this.setTotalQuantity(response.quantity_purchase_orders)
          this.loadTotalAmountPurchaseOrders({ filters: parserFilters(this.filtersPurchaseOrders) })
          this.filtersSupplies.whereIn.id = response.supplies_ids
          this.loadSupplies({ page: 1, filters: parserFilters(this.filtersSupplies) })
        } else {
          this.setTotalQuantity(0)
          this.setTotalAmount(0)
          this.clearPurchaseOrdersTable()
        }
      })
    }
  }
}
</script>

<style></style>
